<template>
    <div class="newsListPage">
        <div class="main">
            <div class="crumb">
                <router-link to="/pcpage/mainpage/home">
                    <span>{{ $t("message.home") }}</span>
                </router-link>
                <span class="icon">></span>
                <span class="current">演讲嘉宾</span>
            </div>
            <div class="list" v-if="guestData&&$i18n.locale=='cn'">
                <div class="avatarCon">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+guestData.avatar" alt="">
                    <div class="guestInfo">
                        <div>{{guestData.realname}}</div>
                        <div class="guestTitle">{{guestData.title}}</div>
                    </div>
                </div>
                <div class="guestProfile">
                    {{guestData.profile}}
                </div>
                <div class="videoCon" v-for="(newsItem, index) in guestData.videos" :key="index">
                    <div class="videoTitle">{{newsItem.title}}</div>
                    <video :src="'http://conference2019.hanban.org'+'/upload/'+newsItem.source" controls></video>
                    <div class="videoDes">{{newsItem.description}}</div>
                </div>
                
            </div>
            <div class="list" v-if="guestData&&$i18n.locale=='en'">
                <div class="avatarCon">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+guestData.avatar" alt="">
                    <div class="guestInfo">
                        <div>{{guestData.realname_en}}</div>
                        <div class="guestTitle">{{guestData.title_en}}</div>
                    </div>
                </div>
                <div class="guestProfile">
                    {{guestData.profile_en}}
                </div>
                <div class="videoCon" v-for="(newsItem, index) in guestData.videos" :key="index">
                    <video :src="'http://conference2019.hanban.org'+'/upload/'+newsItem.source" controls></video>
                </div>
                
            </div>
        </div>
        <!-- <div class="bottom">
            版权所有 © 2019 孔子学院总部     京ICP 备 08002516号-5
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'topicdetail',
    data: function() {
        return {
            guest_id:null,
            guestData: {}
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
    // 判断是否为整数
    isInteger(obj) {
        return obj%1 === 0
    },
    showAll () {
        this.isShow = true
    },
    getNewsList(id) {
      this.$utils
        .get("guest/api/showGuest", {
            lang: this.language,
            id: id,
            with_video: 1
        })
        .then(res => {
          this.guestData = res.data.data
        });
    },
    },
    watch: {
      // 监听切换语言
      language (newval, old) {
          this.getNewsList()
      }
    },
  mounted() {
    this.guest_id = this.$route.query.id
    this.getNewsList(this.guest_id)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newsListPage {
    width: 62.5%;
    height: 100%;
    min-width: 1050px;
    margin: auto;
    background-color: #fff;
    .main {
        padding: 30px 50px 0;
        height: 100%;
        box-sizing: border-box;
        .crumb {
            font-size: 14px;
            a {
                color: #282828;
                text-decoration: none;
            }
            .icon {
                display: inline-block;
                margin: 0 6px;
            }
            .current {
                color: #1c58c1;
            }
        }
        .title {
            margin: 18px 0 18px;
            height: 50px;
            background-color: #e1eef3;
            color: #1c58c1;
            font-size: 28px;
            line-height: 50px;
            font-weight: bold;
            text-indent: 15px;
            .titleName {
                color: #000;
                margin-left: 8px;
            }
        }
        .list {
            height: calc(100% - 101px);
            min-height: 660px;
            padding: 40px 50px;
            .avatarCon {
                img {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                }
                .guestInfo {
                    display: inline-block;
                    vertical-align: top;
                    margin: 30px 40px;
                    word-break: break-all;
                    div:first-child {
                        margin-bottom: 10px;
                        font-size: 18px;
                        color: #282828;
                        font-weight: bold;
                    }
                    div:last-child {
                        font-size: 16px;
                        color: #282828;
                    }
                }
            }
            .videoCon {
                width: 100%;
                margin: 20px 0;
                video {
                    width: 100%;
                    margin: auto;
                }
                .videoTitle {
                    text-align: center;
                    color: #282828;
                    font-weight: bold;
                    font-size: 20px;
                    margin-bottom: 10px;
                    margin-top: 20px;
                }
                .videoDes {
                    font-size: 16px;
                    color: #282828;
                    margin-top: 10px;
                }
            }
            .guestProfile {
                margin: 20px auto;
                font-size: 16px;
                color: #282828;
                line-height: 1.4;
                letter-spacing: 0.08em;
                text-indent: 2em;
                word-break: break-all;
            }

        }
    }
}
    .bottom {
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        opacity: 0.5;
    } 
</style>
